import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { NiceScrollbar, ToasterStyle } from '../utils/css.js';
import { createGlobalStyle } from 'styled-components';
import { useTheme } from '@mui/material';

var NiceScrollGlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), NiceScrollbar);
var ToasterGlobalStyle = createGlobalStyle(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ToasterStyle);
var Reset = createGlobalStyle(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  body {\n    padding: 0;\n    margin: 0;\n    font-size: 100%;\n    overflow: overlay;\n    color-scheme: dark;\n  }\n  \n   a {\n     color: inherit;\n     text-decoration: none;\n   }\n  \n  * {\n    box-sizing: border-box;\n  }\n  \n  ul, li, ol {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n  }\n"], ["\n  body {\n    padding: 0;\n    margin: 0;\n    font-size: 100%;\n    overflow: overlay;\n    color-scheme: dark;\n  }\n  \n   a {\n     color: inherit;\n     text-decoration: none;\n   }\n  \n  * {\n    box-sizing: border-box;\n  }\n  \n  ul, li, ol {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n  }\n"])));
var GlobalAppStyle = function () {
    var theme = useTheme();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Reset, null),
        React__default.createElement(ToasterGlobalStyle, null),
        !!window.isSafari && React__default.createElement(NiceScrollGlobalStyle, null),
        React__default.createElement(GlobalStyles, { styles: {
                body: {
                    fontFamily: theme.typography.fontFamily,
                    background: theme.palette.backgrounds.body,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    color: theme.palette.neutral000,
                    backgroundPositionX: "center",
                    backgroundPositionY: "top",
                },
            } })));
};
var templateObject_1, templateObject_2, templateObject_3;

export { GlobalAppStyle };
